"use client";

import { useState, useEffect } from "react";
const TYPING_MS = 80;
const DELETE_MS = 60;
const PAUSE_MS = 2400;
interface RoleCyclerProps {
  roles: string[];
}
export const RoleCycler: React.FC<RoleCyclerProps> = ({
  roles
}) => {
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [deleting, setDeleting] = useState(false);
  useEffect(() => {
    const word = roles[roleIndex];
    if (!deleting) {
      if (displayed.length < word.length) {
        const t = setTimeout(() => setDisplayed(word.slice(0, displayed.length + 1)), TYPING_MS);
        return () => clearTimeout(t);
      }
      const t = setTimeout(() => setDeleting(true), PAUSE_MS);
      return () => clearTimeout(t);
    }
    if (displayed.length > 0) {
      const t = setTimeout(() => setDisplayed(displayed.slice(0, -1)), DELETE_MS);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setRoleIndex(i => (i + 1) % roles.length);
      setDeleting(false);
    }, DELETE_MS);
    return () => clearTimeout(t);
  }, [displayed, deleting, roleIndex, roles]);
  return <span className="text-brand relative inline-block" data-sentry-component="RoleCycler" data-sentry-source-file="role-cycler.tsx">
      {displayed}
    </span>;
};